import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/App.css";
import { APIBaseLink } from "../components/APIBaseLink";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ResetPasswordPage() {
	const { token } = useParams();
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const navigate = useNavigate();

	const API_BASE_LINK = APIBaseLink();

	const handleResetPassword = async (e) => {
		e.preventDefault();

		if (newPassword !== confirmPassword) {
			toast.error("Passwords Do Not Match.");
			return;
		}

		const obj = { resetToken: token, newPassword };
		const js = JSON.stringify(obj);

		try {
			const response = await fetch(`${API_BASE_LINK}/user/resetPassword`, {
				method: "POST",
				body: js,
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				toast.success("Reset Password Successfully");
				// Redirect to login after a short delay
				setTimeout(() => {
					navigate("/login");
				}, 3000);
			} else {
				const contentType = response.headers.get("content-type");
				let res;
				if (contentType && contentType.indexOf("application/json") !== -1) {
					res = await response.json();
				} else {
					toast.error("Error Resetting Password");
				}
			}
		} catch (err) {
			console.log("Error:", err);
			toast.error("An Error Occurred");
		}
	};

	return (
		<div className="form-page">
			<h1>Reset Password</h1>
			<form onSubmit={handleResetPassword}>
				<div className="form-group">
					<label>New Password:</label>
					<div className="password-input-container">
						<input
							type={showPassword ? "text" : "password"}
							value={newPassword}
							onChange={(e) => setNewPassword(e.target.value)}
							className="password-input"
							required
						/>
						<span className="password-toggle-icon reset-password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
							{showPassword ? "🙈" : "👁️"}
						</span>
					</div>
				</div>
				<div className="form-group">
					<label>Confirm New Password:</label>
					<div className="password-input-container">
						<input
							type={showPassword ? "text" : "password"}
							value={confirmPassword}
							onChange={(e) => setConfirmPassword(e.target.value)}
							className="password-input"
							required
						/>
						<span className="password-toggle-icon reset-password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
							{showPassword ? "🙈" : "👁️"}
						</span>
					</div>
				</div>
				<button type="submit">Reset Password</button>
			</form>
		</div>
	);
}

export default ResetPasswordPage;
